module.exports = __webpack_public_path__ + "img/rank_3.bd6d2cd1.png";